import { makeStyles } from 'tss-react/mui';

const useStylesHeaderSubmenuContainer: MaterialUIStylesCallback = makeStyles()((
  theme: MainTheme,
): MaterialUIStyles => ({
  headerSubmenu: {
    [theme.breakpoints.down('md')]: {
      minWidth: 236,
    },
    [theme.breakpoints.down('sm')]: {
      minWidth: 0,
    },
  },
  headerSubmenuLimited: {
    [theme.breakpoints.down('md')]: {
      minWidth: 148,
    },
  },
}));

export default useStylesHeaderSubmenuContainer;
